import 'isomorphic-form-data';
import ShowellApi from './ShowellApi.js';
export { ShowellApi };
export * from './types/index.js';
export { default as ApiError } from './ApiError.js';
export { default as fetchApi } from './utils/fetchApi.js';
import { createBatchOperation, execBatch } from './utils/batchUtils.js';
export { createBatchOperation, execBatch };
export const BASE_URL = 'https://api.showellapp.com';
const defaultOptions = {
    baseUrl: BASE_URL,
};
/**
 * Initialize Showell API
 */
export default function initialize(options) {
    return new ShowellApi({ ...defaultOptions, ...options });
}
